import { slice } from './slice'

const dialogActions = slice.actions

export default dialogActions
